import React from "react";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import "./pdf.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function Pdf(props) {
  const {
    data: { url, pdfName },
  } = props;

  console.log(url);

  const onDocumentLoadSuccess = ({ numPages }) => { };

  return (
    <>
      {url && (
        <Document
          file={{
            url: `${url}`,
          }}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Page pageNumber={1} />
        </Document>
      )}
    </>
  );
}
